import { RCta } from '../RCta';
import { RIcon } from '../RIcon';
import { RResult } from '../RResult';
import { WCta } from '../WCta';
import { WREG_WORKING_MS } from '../wregSteps';

type WregExceptionTone = 'warm' | 'ok';

type Props = {
  title: string;
  body: string;
  tone?: WregExceptionTone;
  primary?: string;
  onPrimary?: () => void;
  onPrimaryClick?: () => void | Promise<void>;
  loadPrimary?: boolean;
  secondary?: string;
  onSecondary?: () => void;
};

const WregException = ({
  title,
  body,
  tone,
  primary,
  onPrimary,
  onPrimaryClick,
  loadPrimary,
  secondary,
  onSecondary,
}: Props) => (
  <RResult
    badge={tone ?? 'warm'}
    icon={tone === 'ok' ? RIcon.check : RIcon.warning}
    title={title}
    body={body}
    actions={
      <>
        {primary &&
          (loadPrimary ? (
            <WCta minWorkingMs={WREG_WORKING_MS} onClick={onPrimaryClick} onDone={onPrimary}>
              {primary}
            </WCta>
          ) : (
            <RCta onClick={onPrimary}>{primary}</RCta>
          ))}
        {secondary && (
          <RCta variant="ghost" onClick={onSecondary}>
            {secondary}
          </RCta>
        )}
      </>
    }
  />
);

export { WregException };
export type { WregExceptionTone };
